import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-dad06003.js";
const c = {}, r = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, s = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Z",
  clipRule: "evenodd"
}, null, -1), l = [
  s
];
function _(i, d) {
  return e(), o("svg", r, l);
}
const m = /* @__PURE__ */ n(c, [["render", _]]);
export {
  m as default
};
